export const RESULTS_PAGE_SIZE = 32;
